export default "__VITE_ASSET__DveiGX1M__"